import axios from "axios";
import React, { useCallback } from "react";
import Tabletop from "tabletop";

const getSheetData = async (sheetId, workSheetId) => {
  console.log("get");
  console.log(workSheetId);
  let data = Tabletop.init({
    key: sheetId,
    wanted: [workSheetId],
    simpleSheet: true
  }).then(function (response) {
    return response;
  });
  return data;
};

export { getSheetData };
